<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Servicio Complementario
            <v-spacer></v-spacer>
            <v-btn rounded dark color="primary" @click="onEditar" v-html="'Nuevo'"/>
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-sm>
                <v-row dense>
                    <v-col cols="12">
                        <ModalServicioComplementarioComponent :load="obBeneficioModal.abrirModal" 
                                                              :obBeneficioModal="obBeneficioModal" 
                                                              :icono="icono"
                                                              :listGeneral="listGeneral"/>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <ModalTipoServicioComponent :load="obTipoServicioModal.abrirModal" 
                                                    :obTipoServicioModal="obTipoServicioModal" 
                                                    :parametros="parametros"
                                                    :listGeneral="listGeneral"/>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-dialog ref="dialogFechaDesde" v-model="objDate.desde.abrirModal"
                            :return-value.sync="objSearch.fechaVigenciaIni" persistent width="340px">
                            <template v-slot:activator="{ on }">
                                <v-text-field color="textbox" v-model="objSearch.fechaVigenciaIni" label="Fecha Desde *"
                                    prepend-inner-icon="event" readonly outlined dense v-on="on" />
                            </template>
                            <v-date-picker color="primary" v-model="objSearch.fechaVigenciaIni" scrollable locale="es">
                                <v-spacer></v-spacer>
                                <v-btn outlined dense rounded color="danger" @click="objDate.desde.abrirModal = false"
                                    v-html="'Salir'"></v-btn>
                                <v-btn rounded dark color="primary"
                                    @click="$refs.dialogFechaDesde.save(objSearch.fechaVigenciaIni);"
                                    v-html="'Guardar Fecha'"></v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-dialog ref="dialogFechaDesde" v-model="objDate.hasta.abrirModal"
                            :return-value.sync="objSearch.fechaVigenciaFin" persistent width="340px">
                            <template v-slot:activator="{ on }">
                                <v-text-field color="textbox" v-model="objSearch.fechaVigenciaFin" label="Fecha Hasta *"
                                    prepend-inner-icon="event" readonly outlined dense v-on="on" />
                            </template>
                            <v-date-picker color="primary" v-model="objSearch.fechaVigenciaFin" scrollable locale="es">
                                <v-spacer></v-spacer>
                                <v-btn outlined dense rounded color="danger" @click="objDate.hasta.abrirModal = false"
                                    v-html="'Salir'"></v-btn>
                                <v-btn rounded dark color="primary"
                                    @click="$refs.dialogFechaHasta.save(objSearch.fechaVigenciaFin);"
                                    v-html="'Guardar Fecha'"></v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Proveedor *" color="textbox" v-model="objSearch.idProveedor"
                            :items="listGeneral.listProveedor" item-value="idProveedor" item-text="proveedor"
                            outlined dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Tipo de Servicio *" color="textbox" v-model="objSearch.idTipoServicioComp"
                            :items="listGeneral.listTipoServicio" prepend-icon="edit" @click:prepend="editarTipoServicio"
                            outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Estado *" color="textbox" v-model="objSearch.idEstado"
                            :items="listGeneral.listEstado" item-value="id_estado" item-text="nombre_estado"
                            outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-tooltip top color="primary">
                            <template v-slot:activator="{ on }">
                                    <v-btn fab dark small color="primary" @click="onListarServicios" v-on="on"
                                        :disabled="disabled">
                                        <v-icon dark>search</v-icon>
                                    </v-btn>
                            </template>
                            <span>Buscar</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="6" />
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="objSearch.search" clearable
                            prepend-inner-icon="search" dense/>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="12">
                        <v-data-table :search="objSearch.search" :headers="listGeneral.cabecera"
                            :items="listGeneral.detalle" class="elevation-3">
                            
                            <template v-slot:item.name="{ item }">
                                <v-btn class="ma-2" text icon color="primary" @click="onEditar(item)">
                                    <v-icon small>edit</v-icon>
                                </v-btn>
                            </template>
                            
                            <template v-slot:no-results>
                                Tu búsqueda de "<span v-text="objSearch.search"></span>" no arrojó resultados.
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: 'ServicioComplementarioView',
        components:{
            ModalServicioComplementarioComponent: () => import('@/components/beneficio/ModalServicioComplementarioComponent.vue'),
            ModalTipoServicioComponent: () => import('@/components/beneficio/ModalTipoServicioComponent.vue')
        },
        data:() => ({
            objDate:{
                    desde:{ abrirModal:false },
                    hasta:{ abrirModal:false }
                },
            objSearch:{
                opcion:'LISTAR',
                fechaVigenciaIni: moment('2020-01-24').format('YYYY-MM-DD'),
                fechaVigenciaFin: moment().format('YYYY-MM-DD'),
                idProveedor:null,
                idTipoServicioComp: null,
                idEstado:null,
                search:null
            },
            obBeneficioModal:{
                titulo: 'Agregar Servicio Complementario',
                abrirModal: false,
                idEstado:null                
            },
            obTipoServicioModal:{
                abrirModal: false,           
            },
            listGeneral:{},
            parametros:{},
            icono:null
        }),
        created(){
            axios.post(`${BASE_URI}administrador/servicio-complementario/cargaGeneral`,{})
                 .then((r) =>{
                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                    if(_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                        this.$set(this,'listGeneral',r.data.data.listas);
                        this.$set(this,'parametros',r.data.data.parametros);
                        this.objSearch.idProveedor = this.listGeneral.listProveedor[0].idProveedor;
                        this.objSearch.idTipoServicioComp = this.listGeneral.listTipoServicio[0].value;
                        this.objSearch.idEstado = _.toString(this.parametros.id_estado_default);
                        this.obBeneficioModal.idEstado = _.toString(this.parametros.id_estado_default);
                        return this.onListarServicios('L');
                 })
                 .catch((e) =>{
                     mensajesAlerta(e,'E');
                 });
        },
        computed:{
            disabled(){
                return _.size(this.objSearch.fechaVigenciaIni) == 0 && _.size(this.objSearch.fechaVigenciaFin) == 0 ? true : false;
            }
        },
        methods:{
            onEditar(objeto,band = true){
                this.obBeneficioModal = { 
                                            'opcion'    : 'I', 'titulo' : 'Nuevo Servicio Complementario',
                                            'idEstado'  : _.toString(this.parametros.id_estado_default), 'abrirModal': false 
                                        };
                this.icono = null;
                this.obTipoServicioModal.abrirModal = false;

                if(band){
                    if(_.size(_.get(objeto,'idServiciosComp','')) == 0){
                        this.obBeneficioModal.abrirModal = true;
                    }else{
                        this.icono = _.get(objeto,'icono',null);
                        this.obBeneficioModal = _.merge({},
                                                        { 'opcion' : 'U', 'titulo' : 'Editar Servicio Complementario', 'abrirModal': true },
                                                        _.omit(objeto,'icono')
                                                        );
                    }
                }
            },
            editarTipoServicio(objeto){
                if(!_.isUndefined(_.get(objeto,['idTipoServicioComp'],undefined)))
                    this.obTipoServicioModal = objeto;
                    
                this.obTipoServicioModal.abrirModal = true;
            },
            onListarTipoServicio(event){
                if (!_.isUndefined(event)) {
                    var error = 'E';
                    this.listGeneral.listTipoServicio = [];

                    axios.post(`${BASE_URI}administrador/tipo-servicio-complementario/listar`, {
                            opcion: 'LC',
                            idEstado: _.toNumber(_.get(this.objSearch,'idEstado',0)) == 0 ? null : this.objSearch.idEstado
                        })
                        .then((r) => {
                            if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion); }
                                var l = [];
                                l.push({value:null,text:'Todos'});
                                _.map(r.data.data,(v)=>{
                                    l.push({
                                        value: v.idTipoServicioComp,
                                        text: v.tipoServicioComp
                                    });
                                });

                                this.listGeneral.listTipoServicio = l;
                        })
                        .catch((e) => {
                            mensajesAlerta(e, error);
                        });
                }
            },
            onListarServicios(event){
                if(!_.isUndefined(event)){
                    var error = 'E';
                    this.listGeneral.detalle = [];
                    return axios.post(`${BASE_URI}administrador/servicio-complementario/listar`,_.omit(this.objSearch,'search'))
                                .then((r)=>{
                                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                    if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                        this.listGeneral.detalle = _.map(r.data.data,(v)=>{ v.idServiciosComp = v.id; return _.omit(v,'id'); });
                                        return r;
                                })
                                .catch((e) =>{
                                    mensajesAlerta(e,error);
                                    return e;
                                });
                }
            },
            insertarActualizar(objeto){
                var error = 'E';
                return axios.post(`${BASE_URI}administrador/servicio-complementario/insertOrUpdate`,objeto)
                            .then((r)=>{
                                if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                    mensajeAlertaTiempo(r.data.mensaje,'S');
                                    this.$set(this,'icono',null);
                                    this.$forceUpdate();
                                    return this.onListarServicios('L');
                            })
                            .then((r) =>{
                                return true;
                            })
                            .catch((e)=>{
                                mensajesAlerta(e,error);
                                return false;
                            });
            }
        },
        provide(){
            return{
                insertarActualizar: this.insertarActualizar,
                onListarTipoServicio: this.onListarTipoServicio,
                reset             : this.onEditar
            }
        }
    }
</script>
